import { z } from 'zod';
import type { HttpService } from '@web/data/services';

const TRAIL_LIMIT = 100;

const AccessGrantSchema = z.object({
  grantId: z.string(),
  operatorId: z.string(),
  travelerPublicId: z.string(),
  justification: z.string(),
  cardId: z.string().nullable(),
  createdAt: z.coerce.date(),
  expiresAt: z.coerce.date(),
  closedAt: z.coerce.date().nullable(),
});
export type AccessGrant = z.infer<typeof AccessGrantSchema>;

const AccessEventSchema = z.object({
  eventId: z.string(),
  grantId: z.string().nullable(),
  operatorId: z.string(),
  travelerPublicId: z.string().nullable(),
  kind: z.enum(['search', 'read', 'screen']),
  operation: z.string(),
  params: z.record(z.string(), z.string()),
  at: z.coerce.date(),
});
export type AccessEvent = z.infer<typeof AccessEventSchema>;

const TravelerAccessTrailSchema = z.object({
  grants: z.array(AccessGrantSchema),
  events: z.array(AccessEventSchema),
});
type TravelerAccessTrail = z.infer<typeof TravelerAccessTrailSchema>;

/** Exactly one key: who viewed this traveler, or what this operator viewed. */
export type TravelerAccessFilter = { travelerPublicId: string } | { operatorId: string };

export interface TravelerAccessRepository {
  list: (orgId: string, filter: TravelerAccessFilter) => Promise<TravelerAccessTrail>;
}

/** kanban-api `/orgs/:orgId/traveler-access` — the "ver como viajante" audit trail. */
export function createTravelerAccessRepository(http: HttpService): TravelerAccessRepository {
  return {
    list: (orgId, filter) =>
      http.get(`/orgs/${encodeURIComponent(orgId)}/traveler-access`, {
        query: { ...filter, limit: TRAIL_LIMIT },
        schema: TravelerAccessTrailSchema,
      }),
  };
}
